import { render, staticRenderFns } from "./MonitorConfig.vue?vue&type=template&id=487e7eac&"
import script from "./MonitorConfig.vue?vue&type=script&lang=ts&"
export * from "./MonitorConfig.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports